export const CLOUDFLARE_BASE_URL = "https://generations.app/cdn-cgi/image/format=auto,fit=scale-down,width=288,quality=90/"
